import { OrderType, PurchaseOrderStatusType, TransferOrderStatusType } from "customerAttachments/types"

export const OrderTypeMapping: { [key in OrderType]: string } = {
  purchase: "購車訂單",
  transfer: "過戶訂單",
}

export const PurchaseOrderStatusMapping: { [key in PurchaseOrderStatusType]: string } = {
  PendingUpload: "待上傳",
  Uploaded: "已上傳",
  PendingCompletion: "待補件",
}

export const TransferOrderStatusMapping: { [key in TransferOrderStatusType]: string } = {
  PendingUpload: "待上傳",
  Uploaded: "已上傳",
}
